import { css } from '@emotion/css';
import accountBg from 'assets/images/bg/bgHome.jpg';
import { colors } from 'constants/theme';

const accountStyles = {
    wrap: css`
        background: url(${accountBg}) no-repeat;
        background-size: cover;
        height: 100%;
        min-height: 70vh;
        padding: 24px 0;
    `,
    inner: css`
        display: flex;
        height: 100%;
    `,
    left: css`
        border-radius: 4px;
        border: 2px solid #ddca8c;
        margin-right: 10px;
        background-color: ${colors.primary};
        align-self: baseline;
    `,
    group: css`
        .heading-icon {
            transition: 0.25s;
            color: white;
        }
        &.active {
            .heading-icon {
                transform: rotate(180deg);
            }
        }
        .borderTop {
            border-top: 1px solid #ddca8c;
        }
    `,
    groupTitle: css`
        display: flex;
        align-items: center;

        p {
            padding: 8px;
            background: ${colors.secondary};
            border-radius: 8px;
            color: ${colors.white};
            font-weight: 500;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: -15px;
            font-size: 14px;
        }
        .icon {
            width: 25px;
            height: 25px;
        }
    `,
    headingGroup: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        padding: 16px;
        color: #ddca8c;
        width: 250px;

        &:hover {
            background-color: white;
            color: #ddca8c;
        }
        &.active {
            background-image: linear-gradient(90deg, #e4bc62, #dec887, #e4bc62);
        }
    `,
    title: css`
        padding-left: 6px;
        color: #ddca8c;
        font-weight: 400;
        &.active {
            color: #023639;
        }
    `,
    optionList: css`
        height: 0;
        overflow: hidden;
        transition: 0.25s;
    `,
    optionItem: css`
        display: flex;
        align-items: center;
        padding: 16px;
        cursor: pointer;
        gap: 6px;
        background-image: linear-gradient(90deg, #e4bc62, #dec887, #e4bc62);
        border-top: 1px solid #eeeeee;
        transition: all 0.25s ease-in-out;
        img {
            width: 24px;
            margin-right: 6px;
        }
        p {
            flex: 1;
            font-size: 16px;
            color: #040404;
            line-height: 20px;
        }
        &:hover {
            padding-left: 30px;
            p {
                color: ${colors.primary};
            }
            .iconChevron {
                color: #1a957b !important;
            }
        }
        &.active {
            p {
                color: #1a957b;
                font-weight: 400;
            }
            .iconChevron {
                color: #1a957b;
            }
        }
    `,
    right: css`
        flex: 0 0 calc(100% - 250px);
        max-width: calc(100% - 250px);
        /* background: ${colors.darkSecondary}; */
        /* background-size: cover; */
    `,
};
export default accountStyles;
